import { useRouter } from '../../../hooks/useRouter';
import { AppDownloads } from '../AppDownloads';
import { BottomLine } from '../BottomLine';
import {
  LinkColumns,
  LinkSectionView,
  BottomSection,
  Heading,
  Group,
  LinkItem,
} from './LinkSection.styles';
import * as urls from './urls';

export const LinkSection = () => {
  const router = useRouter();

  const isDentist = router?.asPath.includes('dentist');

  return (
    <LinkSectionView>
      <LinkColumns>
        <Group>
          <Heading>Healthengine</Heading>
          <LinkItem to="https://about.healthengine.com.au/">About us</LinkItem>
          <LinkItem to="https://careers.healthengine.com.au/">Careers</LinkItem>
          <LinkItem to="/press">Press centre</LinkItem>
          <LinkItem to="/info">Health articles</LinkItem>
          <LinkItem to="https://practices.healthengine.com.au/?pracsource=footer-prac-services">
            Practice services
          </LinkItem>
          <LinkItem to="https://partnerservices.healthengine.com.au">Partner services</LinkItem>
          <LinkItem to="https://privacy.healthengine.com.au/">Privacy and security</LinkItem>
          <LinkItem to="/app/">Mobile app</LinkItem>
          <LinkItem to="https://support.healthengine.com.au/hc/en-us/sections/201416433-General-FAQs">
            Help centre
          </LinkItem>
          <LinkItem to="https://support.healthengine.com.au/">Contact us</LinkItem>
        </Group>

        <Group>
          <Heading>Find a provider</Heading>
          <LinkItem to={urls.GP_APPOINTMENTS}>GP appointments</LinkItem>
          <LinkItem to="/find/gp/Australia">Find a Doctor</LinkItem>
          <LinkItem to={urls.AFTER_HOURS_GP_APPOINTMENTS}>After hours GP appointments</LinkItem>
          <LinkItem to={urls.BULK_BILLING_GP_APPOINTMENTS}>Bulk billing GP appointments</LinkItem>
          <LinkItem to={urls.DENTIST_APPOINTMENTS}>Dentists appointments</LinkItem>
          <LinkItem to={urls.PHYSIO_APPOINTMENTS}>Physiotherapist appointments</LinkItem>
          <LinkItem to={urls.CHIRO_APPOINTMENTS}>Chiropractor appointments</LinkItem>
          <LinkItem to={urls.PSYCH_APPOINTMENTS}>Psychologist appointments</LinkItem>
          <LinkItem to="https://practices.healthengine.com.au/?pracsource=footer-list-appointments">
            List your appointments
          </LinkItem>
          <LinkItem to="https://support.healthengine.com.au/hc/en-us/articles/210618263-How-can-I-cancel-an-appointment-I-booked-online-">
            Cancel appointment
          </LinkItem>
        </Group>

        <Group>
          <Heading>Directory</Heading>

          <LinkItem to="/findapractitioner.php">Find a practitioner</LinkItem>
          <LinkItem to="https://practices.healthengine.com.au/list-your-practice/?pracsource=footer-list-practice">
            List your practice
          </LinkItem>
          {isDentist && <LinkItem to={urls.DENTIST}>Find a dentist</LinkItem>}
          {isDentist && <LinkItem to={urls.SYDNEY_DENTISTS}>Sydney dentists</LinkItem>}
          {isDentist && <LinkItem to={urls.MELBOURNE_DENTISTS}>Melbourne dentists</LinkItem>}
          {isDentist && <LinkItem to={urls.BRISBANE_DENTISTS}>Brisbane dentists</LinkItem>}
          {isDentist && <LinkItem to="/find-dentist/cheap-dentist">Cheap dentist</LinkItem>}
          <LinkItem to={urls.ONLINE_DOCTORS}>Online doctors</LinkItem>
          <LinkItem to={urls.ONLINE_GPS}>Online GPs</LinkItem>
          <LinkItem to="/flu-vaccine/book-online">Flu Vaccine</LinkItem>
        </Group>

        <Group>
          <Heading>Login</Heading>

          <LinkItem to="/members/login">Patient login</LinkItem>
          <LinkItem to="/appointment/admin/">Practice login</LinkItem>
        </Group>

        <Group>
          <Heading>Feedback</Heading>

          <LinkItem to="https://support.healthengine.com.au/hc/en-us/articles/4402395572633-How-do-I-lodge-a-complaint-">
            Make a complaint
          </LinkItem>
        </Group>
      </LinkColumns>

      <BottomSection>
        <BottomLine />
        <AppDownloads />
      </BottomSection>
    </LinkSectionView>
  );
};
